import React, { useEffect, useState } from "react";
import Loader from "../../../../Loader/Loader";
import DashboardMenu from "../../../layout/dashboardMenu";
import Header from "../../../layout/header";
import ReactPaginate from "react-paginate";
import NotFoundData from "../../../../Images/no-data-found.webp";
const TicketDetails = ({
  history,
  getjuniorListingForHod,
  juniorListHod = [],
  selfRatingDetails,
  selfListing = [],
  fetchTicketDetails,
  getTicketDetails = [],
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [filterInputList, setFilterInputList] = useState([{}]);
  const [open, setOpen] = useState(false);
  const [isFilterRemove, setIsRemoveFilter] = useState(false);
  const [pageNo, setPage] = useState(1);
  const [month, setMonth] = useState("");
  const [userId, setUserId] = useState(0);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await fetchTicketDetails(1);
      setIsLoading(false);
    })();
  }, []);

  const handleFilter = async (key, value, stringValue = "") => {
    const list = [...filterInputList];
    list[0][key] = value;
    setFilterInputList(list);
  };

  const onPageChange = async (val) => {
    setIsLoading(true);
    await getjuniorListingForHod(val?.selected + 1);
    setIsLoading(false);
  };

  const handleSubmitFilter = async () => {
    setOpen(false);
    setIsLoading(true);
    await selfRatingDetails(localStorage.getItem("user_id"), filterInputList);
    setIsLoading(false);
  };

  const handleRemoveFilter = async (key) => {
    if (key !== "") {
      delete filterInputList[0][key];
      setFilterInputList(filterInputList);
      setIsLoading(true);
      await selfRatingDetails(localStorage.getItem("user_id"), filterInputList);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    (async () => {
      if (isFilterRemove) {
        setFilterInputList([{}]);
        setIsLoading(true);
        await selfRatingDetails(localStorage.getItem("user_id"));
        setIsLoading(false);
        setIsRemoveFilter(false);
      }
    })();
  }, [isFilterRemove]);

  console.log("GET DETAILS:", getTicketDetails);

  return (
    <>
      <Loader isLoading={isLoading} />
      <div id="wrapper">
        <DashboardMenu />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Header title={"Ticket Details"} history={history} />
            <div className="container-fluid common-bg">
              <div className="container-fluid bootstrap snippets bg-white">
                {/* <div className="d-sm-flex align-items-center justify-content-between">
                  <div className="row col-md-12">
                    <button
                      onClick={() => setOpen(!open)}
                      className="btn btn-sm btn-primary mr-1 btn-filter mt-2"
                      type="button"
                    >
                      <i className="fa fa-filter lh-35 pd-3"></i>
                    </button>
                  </div>
                </div> */}
                <div className="row mt-5">
                  {getTicketDetails &&
                    getTicketDetails.data &&
                    getTicketDetails.data.resultSets &&
                    getTicketDetails.data.resultSets.length > 0 &&
                    getTicketDetails.data.resultSets.map((ticket, index) => (
                      <div key={index} className="col-md-4 col-sm-6 mt-6">
                        <div className="card-big-shadow">
                          <div
                            className="card card-just-text"
                            data-background=""
                            data-color=""
                            data-radius="none"
                          >
                            <div className="content">
                              <h6 className="category mrg-b-12">
                                <div className="row list-view mt-4">
                                  <div className="mb-flex mt-2">
                                    <div className="col-md-6 col-sm-6 no-wrap">
                                      <i
                                        className="fas fa-ticket-alt"
                                        style={{ color: "red" }}
                                        aria-hidden="true"
                                      ></i>
                                      &nbsp;&nbsp;Ticket Id:
                                    </div>
                                    <div className="col-md-6 col-sm-6 l2">
                                      <span
                                        className="trigger float-right mr-1"
                                        data-tooltip-id="1"
                                        title={ticket.id}
                                      >
                                        {ticket.id}
                                      </span>
                                    </div>
                                  </div>
                                  <div className="mb-flex mt-2">
                                    <div className="col-md-6 col-sm-6 no-wrap">
                                      <i
                                        className="fa fa-question-circle"
                                        style={{ color: "green" }}
                                        aria-hidden="true"
                                      ></i>
                                      &nbsp;&nbsp;Description:
                                    </div>
                                    <div className="col-md-6 col-sm-6 l2">
                                      <span
                                        className="trigger float-right mr-1"
                                        data-tooltip-id="1"
                                        title={ticket.complain_description}
                                      >
                                        {ticket.complain_description}
                                      </span>
                                    </div>
                                  </div>
                                  <div className="mb-flex mt-2">
                                    <div className="col-md-6 col-sm-6 no-wrap">
                                      <i
                                        className="fa fa-calendar"
                                        style={{ color: "#1325a8" }}
                                        aria-hidden="true"
                                      ></i>
                                      &nbsp;&nbsp;Created On:
                                    </div>
                                    <div className="col-md-6 col-sm-6 l2">
                                      <span
                                        className="trigger float-right mr-4"
                                        data-tooltip-id="1"
                                        title={ticket.created_at}
                                      >
                                        {ticket.created_at}
                                      </span>
                                    </div>
                                  </div>
                                  <div className="mb-flex mt-2">
                                    <div className="col-md-6 col-sm-6 no-wrap">
                                      <i
                                        className="fa fa-heartbeat"
                                        style={{ color: "#c4a715" }}
                                        aria-hidden="true"
                                      ></i>
                                      &nbsp;&nbsp;Status:
                                    </div>
                                    <div className="col-md-6 col-sm-6 l2">
                                      <span
                                        className="trigger float-right mr-4"
                                        data-tooltip-id="1"
                                        title={ticket.internal_status}
                                      >
                                        {ticket.internal_status}
                                      </span>
                                    </div>
                                  </div>
                                  <div className="mb-flex mt-2">
                                    <div className="col-md-6 col-sm-6 no-wrap">
                                      <i
                                        className="fas fa-paperclip"
                                        style={{ color: "#802400" }}
                                        aria-hidden="true"
                                      ></i>
                                      &nbsp;&nbsp;User Attachment:
                                    </div>
                                    <div className="col-md-6 col-sm-6 l2">
                                      <a
                                        href={ticket.attachment}
                                        target="blank"
                                      >
                                        <i class="fa fa-download float-right mr-4"></i>
                                      </a>
                                    </div>
                                  </div>
                                  {ticket && ticket.l2_reply && (
                                    <div className="mb-flex mt-2">
                                      <div className="col-md-6 col-sm-6 no-wrap">
                                        <i
                                          className="fas fa-reply-all"
                                          style={{ color: "purple" }}
                                          aria-hidden="true"
                                        ></i>
                                        &nbsp;&nbsp;L2 Reply:
                                      </div>
                                      <div className="col-md-6 col-sm-6 l2">
                                        <span
                                          className="trigger float-right mr-4"
                                          data-tooltip-id="1"
                                          title={ticket.l2_reply}
                                        >
                                          {ticket.l2_reply}
                                        </span>
                                      </div>
                                    </div>
                                  )}
                                  {ticket && ticket.l2_attachment && (
                                    <div className="mb-flex mt-2">
                                      <div className="col-md-6 col-sm-6 no-wrap">
                                        <i
                                          className="fas fa-paperclip"
                                          style={{ color: "black" }}
                                          aria-hidden="true"
                                        ></i>
                                        &nbsp;&nbsp;L2 Attachment:
                                      </div>
                                      <div className="col-md-6 col-sm-6 l2">
                                        <a
                                          href={ticket.l2_attachment}
                                          target="blank"
                                        >
                                          <i class="fa fa-download float-right mr-4"></i>
                                        </a>
                                      </div>
                                    </div>
                                  )}
                                  {ticket && ticket.l2_reply_time && (
                                    <div className="mb-flex mt-2">
                                      <div className="col-md-6 col-sm-6 no-wrap">
                                        <i
                                          className="far fa-clock"
                                          style={{ color: "blue" }}
                                          aria-hidden="true"
                                        ></i>
                                        &nbsp;&nbsp;Resolution Time:
                                      </div>
                                      <div className="col-md-6 col-sm-6 l2">
                                        <span
                                          className="trigger float-right mr-4"
                                          data-tooltip-id="1"
                                          title={'Resolution Time'}
                                        >
                                          {ticket.l2_reply_time}
                                        </span>
                                      </div>
                                    </div>
                                  )}
                                  
                                </div>
                                <hr />
                              </h6>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  {getTicketDetails &&
                    getTicketDetails.data &&
                    getTicketDetails.data.resultSets &&
                    getTicketDetails.data.resultSets.length === 0 && (
                      <>
                        <img
                          src={NotFoundData}
                          className="not-found-data"
                          alt=""
                        />
                        <div className="text-center" style={{ width: "100%" }}>
                          Data Not Found
                        </div>
                      </>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TicketDetails;
